import { Button } from "@/components/ui/button";
import Card from "@/components/ui/card";
import { LogoutButton } from "@/features/user-settings";
import { Link } from "@tanstack/react-router";

export const NoOrganizations = () => {
  return (
    <div
      data-testid="noOrganizationsCard"
      className="flex flex-col justify-center items-center w-full gap-20 mt-32"
    >
      <Card data-testid="selectOrganizationCard" className="w-96">
        <Card.Header className="gap-1">
          <Card.Title className="text-2xl text-center">Welcome!</Card.Title>
          <Card.Description className="text-center">
            It looks like you don&apos;t have any organizations yet. Create one
            to get started!
          </Card.Description>

          <Card.Content className="flex justify-center">
            <Link
              to="/organization-create"
              search={{ redirect: undefined }}
              className="mt-6 w-full"
            >
              <Button size="lg" className="w-full">
                Create organization
              </Button>
            </Link>
          </Card.Content>
        </Card.Header>
      </Card>
      <LogoutButton />
    </div>
  );
};
